@if (term(); as t) {
  @if (notice(); as n) {
    <section class="consent-card" aria-labelledby="deal-consent-title">
      <h3 class="consent-card__title" id="deal-consent-title">Consentimento SCR</h3>
      <p class="consent-card__doc">Carta de autorização de SCR</p>

      <div
        class="consent-card__status"
        [class.consent-card__status--pending]="n.tone !== 'signed'"
        role="status">
        <i
          class="pi"
          [class.pi-check-circle]="n.tone === 'signed'"
          [class.pi-clock]="n.tone !== 'signed'"
          aria-hidden="true"></i>
        <span>
          @switch (n.tone) {
            @case ('signed') {
              <strong>Assinado em {{ n.signedAt | vaultDateTime }}.</strong>
              Consultas restritivas liberadas a partir desta data.
            }
            @case ('waiting') {
              <strong>Aguardando a assinatura do cliente.</strong>
              As consultas restritivas só são liberadas depois dela.
            }
            @default {
              <strong>Ainda não enviado ao cliente.</strong>
              As consultas restritivas só são liberadas depois da assinatura.
            }
          }
        </span>
      </div>

      <dl class="consent-card__rows">
        @if (n.tone === 'signed' && t.expiresAt) {
          <div class="consent-card__row">
            <dt>Válido até</dt>
            <dd>{{ t.expiresAt | vaultDate }}</dd>
          </div>
        }
        <div class="consent-card__row">
          <dt>Versão</dt>
          <dd>{{ t.termsVersion }}</dd>
        </div>
      </dl>

      @if (t.reusedFromAnotherDeal) {
        <span class="consent-card__reused">
          <i class="pi pi-link" aria-hidden="true"></i>
          Assinado num deal anterior desta empresa
        </span>
      }

      @if (clientSignatories().length) {
        <h4 class="consent-card__subtitle">Assinantes do cliente</h4>
        <ul class="consent-card__signers">
          @for (s of clientSignatories(); track s.id) {
            <li class="consent-card__signer">
              <span class="consent-card__who">
                <strong>{{ s.name }}</strong>
                @if (s.qualification) {
                  <small>{{ s.qualification }}</small>
                }
              </span>
              @if (s.signedAt) {
                <span class="consent-card__when">
                  <i class="pi pi-check-circle" aria-hidden="true"></i>
                  {{ s.signedAt | vaultDateTime }}
                </span>
              } @else {
                <span class="consent-card__pending">Ainda não assinou</span>
              }
            </li>
          }
        </ul>
      }

      <app-button
        class="consent-card__action"
        [label]="'Ver documento'"
        [icon]="'eye'"
        [theme]="'outline-grey'"
        [isLoading]="openingTerm()"
        [loadingText]="'Abrindo...'"
        [type]="'button'"
        (sendButtonClick)="openTerm.emit()"></app-button>
    </section>
  }
}
